import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  header: {},
  body: {
    paddingBottom: theme.spacing(1),
  },
  bodyText: {
    color: theme.palette.common.gray800,
    lineHeight: '20px',
  },
  footer: {
    '& button': {
      width: 'unset',

      '&:last-of-type': {
        marginLeft: theme.spacing(2),
      },
    },
  },
}));
